/**
 * gtmTrack
 */

const gtmTrack = options => {
  if ('dataLayer' in window) window.dataLayer.push(options);
};

export default gtmTrack;
